import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MainIngredientSection() {
  return <section className="py-12" data-id="element-85">
      <div className="max-w-2xl mx-auto editorial-text" data-id="element-86">
        <FadeIn data-id="element-87">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-88">
            How One Overlooked Mineral Collapses The Biofilm Fortress — Without
            Harming A Single Healthy Bacteria
          </h2>
          <div className="rounded-xl overflow-hidden mb-6" data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/4fR4DRje8i9jeyEFhsrAQW/hf_20260403_031253_ec113a6a-b928-46e5-a1a9-b880dfc8f585_(1).png" alt="Microscopic view of mineral particles collapsing biofilm on tooth enamel" className="w-full h-auto object-cover" data-id="element-90" />
          </div>
          <p data-id="element-91">
            Now you may be wondering what this remarkable ingredient is, and why
            researchers call it "liquid enamel"...
          </p>
          <p data-id="element-92">
            Well that's simple - because it's quite literally made up of the
            exact minerals your teeth are made of.
          </p>
          <p className="font-[700]" data-id="element-93">
            Did you know your teeth aren't actually made of bone?
          </p>
          <p data-id="element-94">That's a common misconception…</p>
          <p data-id="element-95">
            And indeed one that surprises my patients when they first hear it.
          </p>
          <p data-id="element-96">Instead, your tooth enamel is approximately 97% hydroxyapatite.</p>
          <p data-id="element-97">
            Incredible right? Imagine giving your own teeth the very building
            blocks they are made of.
          </p>
          <p data-id="element-98">
            That's like finally watering a garden of plants who haven't seen
            water in months, if not years. The literal thing they need to
            survive.
          </p>
          <p className="font-[700]" data-id="element-99">
            But here's what makes it really special - and it's the key to
            finally ending the biofilm crisis in your mouth.
          </p>
          <p data-id="element-100">
            Remember how biofilm quite literally changes your enamel's
            composition in order for it to thrive?
          </p>
          <p data-id="element-101">
            Hydroxyapatite, on the other hand, acts as a "protective shield"
            that makes the terrain for the biofilm inhabitable.
          </p>
          <p data-id="element-102">It might seem like magic - but it's not. It's science.</p>
          <p data-id="element-103">
            See, when hydroxyapatite is delivered in a format that allows it to
            spend enough time in the mouth - such as a slowly dissolving tablet
            - its particles bond directly to the tooth surface.
          </p>
          <p data-id="element-104">
            These particles fill the micro-cracks that would otherwise serve as
            anchoring points for biofilm.
          </p>
          <p data-id="element-105">
            In fact, in one clinical study done in 2017, researchers scanned the
            surfaces of enamel treated with hydroxyapatite - and they found the
            enamel was significantly smoother and more intact.
          </p>
          <p data-id="element-106">Why does this matter?</p>
          <p data-id="element-107">
            Because biofilm requires a rough surface to gain initial traction -
            one with cracks and defects.
          </p>
          <p className="font-[700]" data-id="element-108">
            So when hydroxyapatite physically smooths the terrain, it creates a
            surface where biofilm can't effectively grip or organize.
          </p>
          <p data-id="element-109">
            In fact, research found this process is just as effective as
            chlorohexidine - the strongest prescription mouthwash - in getting
            rid of bacteria on the surface of your teeth.
          </p>
          <p data-id="element-110">
            And the best part? It does so without killing any of the healthy
            bacteria in your mouth.
          </p>
          <p data-id="element-111">
            This is simply incredible. Because this means you can essentially
            "powerwash" your mouth to get rid of the biofilm along with the bad
            bacteria hiding behind it..
          </p>
          <p data-id="element-112">
            In turn, your good bacteria can finally get to work with a healed
            foundation.
          </p>
          <p data-id="element-113">
            It's truly a cutting-edge process. And it's completely painless.
          </p>
          <p data-id="element-114">
            Not to mention, it doesn't even come close to how much a cleaning
            costs.
          </p>
          <p data-id="element-115">
            I hope you see why I recommend this incredible mineral to my
            patients.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-116">
          <div className="my-12 py-8 border-t border-b border-gray-200" data-id="element-117">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-118">
              But You May Be Wondering - Why Hasn't Your Dentist Told You About
              It?
            </h2>
            <div className="rounded-xl overflow-hidden my-6" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/twEdYkp7yCG3HpoojVPx5B/Sim-lab_0_(1).jpg" alt="Dental students training in a simulation lab" className="w-full h-auto object-cover" data-id="element-120" />
            </div>
            <p data-id="element-121">
              And the answer is - as unfortunate as it is - we were never
              trained in it.
            </p>
            <p data-id="element-122">
              See, dental school curricula is built around fluoride, drilling,
              and filling.
            </p>
            <p data-id="element-123">
              Even the oral microbiome is not taught - otherwise you would be
              aware of the biofilm crisis in your mouth right now.
            </p>
            <p data-id="element-124">
              This is how things have been for years - and it's probably how
              they will remain.
            </p>
            <p data-id="element-125">
              Hydroxyapatite - along with the discovery about the oral
              microbiome - is a relatively recent paradigm shift.
            </p>
            <p data-id="element-126">
              The only way your dentist would know about this is if they went
              looking for it themselves.
            </p>
            <p data-id="element-127">
              However, most don't — not because they don't care, but because
              when you've been practicing the same way for 20 or 30 years, you
              stop questioning the foundation.
            </p>
            <p data-id="element-128">And the ones who have heard of hydroxyapatite?</p>
            <p data-id="element-129">They typically recommend their patients the wrong version…</p>
            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-6" data-id="element-130">
              Why Most Dentists Who Recommend Hydroxyapatite Are Actually
              Recommending The Wrong Version
            </h3>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/ffsejKK7zpyEUhWWVoazLF/nano_hydroxyapatite_enamel_callouts.webp" alt="Diagram comparing nano-hydroxyapatite and micro-hydroxyapatite particle sizes on tooth enamel" className="w-full h-auto object-cover" data-id="element-132" />
            </div>
            <p data-id="element-133">
              Now before you worry about having to figure out which one is right
              — I'm going to make it extremely simple for you right now.
            </p>
            <p data-id="element-134">Because there are two versions of hydroxyapatite.</p>
            <p data-id="element-135">
              And the main difference between them is simply their particle
              size.
            </p>
            <p data-id="element-136">
              The first one is nano-hydroxyapatite, and the second one is
              micro-hydroxyapatite.
            </p>
            <p className="font-[700]" data-id="element-137">
              While both are proven to be just as effective as each other,
              there's a catch.
            </p>
            <p data-id="element-138">
              See, not only is nano-hydroxyapatite the synthetic version -
              meaning created in a lab…
            </p>
            <p data-id="element-139">
              But its particles are also extremely tiny and invisible to the
              human eye.
            </p>
            <p data-id="element-140">
              And because they're so tiny, they can accidentally cross into your
              bloodstream.
            </p>
            <p className="font-[700]" data-id="element-141">
              In fact, this is something that raised enough concern for the
              European Union to restrict its use entirely - due to potential
              toxicity.
            </p>
            <p data-id="element-142">
              Now should you use it considering it's not restricted in the
              United States?
            </p>
            <p data-id="element-143">
              That's totally up to you - but the reason why I stay away from it
              is simple.
            </p>
            <p className="font-[700]" data-id="element-144">
              Because the other version - microhydroxyapatite - is not only just
              as effective…
            </p>
            <p data-id="element-145">
              But it's completely natural - derived from the bones of young
              pasture-raised cattle in New Zealand and Australia.
            </p>
            <p data-id="element-146">
              These pastures are often described as free-range - meaning some of
              the best nutrients nature has to offer.
            </p>
            <p data-id="element-147">
              Not only that, but you won't have to worry about the particles
              crossing into your bloodstream, potentially causing toxicity.
            </p>
            <p data-id="element-148">
              Why? Because unlike the nano version, its particles are too large
              to cross into the bloodstream.
            </p>
            <p className="font-[700]" data-id="element-149">
              This makes it completely safe for all age groups - even pregnant
              women and children.
            </p>
            <p data-id="element-150">Now you see why I recommend this version. It's simply safer.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-151">
          <p data-id="element-152">But hydroxyapatite alone is only half the solution.</p>
          <p data-id="element-153">
            Remember — you still need to restore the oral microbiome to a state
            of healthy dominance.
          </p>
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-6" data-id="element-154">
            What I Discovered About Oral Probiotics That Made Me Create My Own…
          </h2>
          <div className="rounded-xl overflow-hidden mb-6" data-id="element-155">
            <img src="https://cdn.magicpatterns.com/uploads/2iEKS3dXjQGh7hUT2UqZqr/hf_20260312_010714_da5f166a-91b6-4008-a88f-02d93b1deb22_(1)_(1)_(1).jpg" alt="Research papers on bioactive compounds displayed on a laptop with notes" className="w-full h-auto object-cover" data-id="element-156" />
          </div>
          <p data-id="element-157">
            Now for me for atleast, prescribing to my patients some random
            probiotic - that may or may not contain the correct version of
            hydroxyapatite their teeth needed just wasn't an option…
          </p>
          <p data-id="element-158">
            And that's assuming they use the correct strains of bacteria,
            because most don't.
          </p>
          <p data-id="element-159">
            Instead, they dilute the effectiveness by adding in unnecessary
            strains of bacteria - to claim it has a "higher healthy bacteria" in
            their marketing…
          </p>
          <p className="font-[700]" data-id="element-160">
            That's not how it works. Because there are exactly three strains you
            need. No more. No less.
          </p>
          <p data-id="element-161">Knowing this, I designed one that suits my patients needs.</p>
          <p data-id="element-162">
            And now for the first time ever — it's available outside of my
            practice.
          </p>
          <p data-id="element-163">But here's what makes this moment different.</p>
          <p data-id="element-164">
            Since this is the first time we're making it available online — it's
            also the most advanced version we've ever formulated.
          </p>
          <p className="font-[700]" data-id="element-165">
            After years of refining this in my practice, watching what worked
            and what my patients still needed more of — we added two additional
            ingredients to the formula.
          </p>
          <p data-id="element-166">
            Ones that take everything hydroxyapatite and the three bacterial
            strains already do — and make them work faster, last longer, and go
            deeper.
          </p>
          <p data-id="element-167">
            This version has never existed before today. And you're one of the
            first to get your hands on it.
          </p>
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-6" data-id="element-168">
            But before we get to that, it would be quite rude for me to not
            reintroduce myself.
          </h2>
          <div className="rounded-xl overflow-hidden mb-6" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/r3yhaoRKSdGJDY8oYGhCby/hf_20260403_070147_35a38373-ac26-4dc0-ba94-96af08b6971f_(1).png" alt="Dr. Emily Chen with a happy customer testimonial from Jessica Miramontes" className="w-full h-auto object-cover" data-id="element-170" />
          </div>
          <p data-id="element-171">
            My name is Dr. Emily Chen, Doctor of Dental Medicine and practicing
            dentist for over 8 years across two offices in Southern California.
          </p>
          <p data-id="element-172">
            When I started looking for something to recommend to my patients
            between visits, every product I came across was either built around
            outdated fluoride science, loaded with the same antibacterial
            chemicals destroying their oral microbiome, or using the wrong
            version of hydroxyapatite with zero regard for safety.
          </p>
          <p data-id="element-173">
            So I sourced microcrystalline hydroxyapatite derived exclusively
            from pasture-raised cattle in New Zealand and Australia — some of
            the most nutrient-rich pastures in the world.
          </p>
          <p data-id="element-174">
            Then I paired it with the exact three bacterial strains the clinical
            research pointed to.
          </p>
          <p data-id="element-175">
            Not ten strains. Not fifteen. Three — each with a specific job to
            do.
          </p>
          <p className="font-[700]" data-id="element-176">
            Let me tell you what those three strains are and exactly what they
            do.
          </p>
          <p data-id="element-177">I like to call these 3 strains the "biological guard". Why?</p>
          <p data-id="element-178">
            Because while the "physical shield" - hydroxyapatite - makes the
            surface inhospitable for biofilm…
          </p>
          <p data-id="element-179">
            These 3 cutting-edge strains of bacteria address the cause of
            biofilm formation by restoring the oral microbiome to a state of
            healthy dominance.
          </p>
        </FadeIn>

        <div className="my-12 space-y-6" data-id="element-180">
          <FadeIn data-id="element-181">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-182">
              <h3 className="font-sans text-xl font-bold text-gray-900 mb-2" data-id="element-183">
                Strain 1: Lactobacillus Salivarius{' '}
                <span className="text-teal-600" data-id="element-184">— "The Disruptor"</span>
              </h3>
              <div className="text-gray-700 space-y-4" data-id="element-185">
                <p data-id="element-186">
                  Not only does it stop the organization of biofilm, but it also
                  helps maintain a healthy pH environment that supports the
                  remineralization efforts of hydroxyapatite.
                </p>
                <p data-id="element-187">
                  See, when your mouth's pH drops below 5.5, it enters a
                  critical "danger zone" where enamel begins to demineralize,
                  leading to tooth erosion, increased sensitivity, and a high
                  risk of cavities.
                </p>
                <p data-id="element-188">
                  This is incredibly normal and common because the modern diet
                  is packed with hidden acids and sugars which cause this.
                </p>
                <p data-id="element-189">
                  In fact, everyone's mouth pH drops into that "danger zone"
                  multiple times every single day.
                </p>
                <p data-id="element-190">
                  Lactobacillus Salivarius is a crucial part of this formulation
                  because it balances your pH levels so hydroxyapatite
                  effectively disrupts biofilm.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-191">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-192">
              <h3 className="font-sans text-xl font-bold text-gray-900 mb-2" data-id="element-193">
                Strain 2: Lactobacillus Paracasei{' '}
                <span className="text-teal-600" data-id="element-194">— "The Bouncer"</span>
              </h3>
              <div className="text-gray-700 space-y-4" data-id="element-195">
                <p data-id="element-196">
                  Why? Because it provides sustained protection by establishing
                  dominance in your oral microbiome…
                </p>
                <p data-id="element-197">
                  Essentially, "crowding out" the bacteria that would otherwise
                  contribute to dental problems - and it does so effectively.
                </p>
                <p data-id="element-198">
                  In fact, a long-term controlled trial - involving 122 children
                  - demonstrated that taking this bacteria for 6 months resulted
                  in a significant reduction in the very bacteria that forms
                  biofilm, called S. mutans.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-199">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-200">
              <h3 className="font-sans text-xl font-bold text-gray-900 mb-2" data-id="element-201">
                Strain 3: Lactobacillus Acidophilus{' '}
                <span className="text-teal-600" data-id="element-202">— "The Resistor"</span>
              </h3>
              <div className="text-gray-700 space-y-4" data-id="element-203">
                <p data-id="element-204">
                  While L. acidophilus is a well-known gut probiotic, it is
                  extremely powerful in supporting the oral microbiome as well.
                </p>
                <p data-id="element-205">
                  It prevents the further colonization of harmful bacteria and
                  reduces the overall toxicity of the oral biofilm to support
                  healthy gum growth.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn data-id="element-206">
          <p data-id="element-207">
            Once I had the correct bacteria strains - along with the
            hydroxyapatite - I tweaked the formula again and again until I had
            something my patients would actually look forward to taking every
            morning.
          </p>
          <p className="font-[700]" data-id="element-208">
            That's when we knew we had something nobody else had.
          </p>
          <p data-id="element-209">
            The first dental chew that solves the Biofilm Crisis at its root —
            rebuilding the enamel biofilm destroyed, and rearming the bacterial
            defense conventional dentistry wiped out.
          </p>
          <p data-id="element-210">
            Now, even though this formula was potent as is - I didn't stop
            there.
          </p>
          <p data-id="element-211">
            After years of refining and applying customer feedback, I added two
            more ingredients specifically to enhance their effects.
          </p>
          <p className="font-[700]" data-id="element-212">
            The first is Xylitol — a natural compound that starves biofilm
            bacteria of the energy they need to build and organize.
          </p>
          <p data-id="element-213">
            Essentially, it cuts off the bacterias fuel supply while the
            biological guard moves in.
          </p>
          <p className="font-[700]" data-id="element-214">
            The second is Guava Leaf Extract — a botanical that reduces gum
            inflammation and makes it nearly impossible for new bacteria to gain
            traction on your teeth.
          </p>
          <p data-id="element-215">
            Think of it as making the surface permanently slippery for anything
            that tries to anchor itself.
          </p>
        </FadeIn>
      </div>
    </section>;
}